import { TOGGLER } from "../actionTypes";

const toggle = () => ({
  type: TOGGLER,
});

export default toggle;
